module.exports = __webpack_public_path__ + "img/certificate-6.7e085779.jpg";